import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=56aeae3a&scoped=true"
import script from "./refund.vue?vue&type=script&lang=js"
export * from "./refund.vue?vue&type=script&lang=js"
import style0 from "./refund.vue?vue&type=style&index=0&id=56aeae3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aeae3a",
  null
  
)

export default component.exports